<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-ios-filing-outline"></i>
        <div class="mg-l-20">
          <h4>{{ $t("warehouse.仓库管理") }}</h4>
        </div>
      </div>
      <div class="tx-right">
        <button class="btn btn-success" @click="editStore">
          {{ $t("warehouse.添加仓库") }}
        </button>
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30"
    >
      <div class="clear-key">
        <a
          v-show="keyName"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('keyName')"
        >
          {{ $t("warehouse.仓库名：") }}
          <span class="mg-r-10">{{ keyName }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="keyStatus"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('keyStatus')"
        >
          {{ $t("warehouse.仓库名：") }}
          <span class="mg-r-10">{{ $t($dict.storeStatus[keyStatus]) }}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["keyName", "keyStatus"],
  methods: {
    editStore() {
      this.$emit("editStore");
    },
    clearKey(type) {
      this.$emit("clearKey", type);
    },
  },
};
</script>
